// extracted by mini-css-extract-plugin
export var container = "price-module--container--wyndE";
export var originalPrice = "price-module--original-price--2mdO+";
export var priceLoader = "price-module--price-loader--nkhRN";